// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"2c69df23","459":"a62c24e1"}[chunkId] + ".chunk.js";
};